<template>
  <v-container fluid dir="rtl">
    <v-alert v-if="!isManager" type="warning" outlined>این بخش فقط برای مدیر کل قابل دسترسی است.</v-alert>
    <v-card v-else outlined class="pa-5 rounded-lg" max-width="650">
      <h1 class="text-h5 font-weight-bold mb-3">هزینه ارسال</h1>
      <p class="text-body-2 grey--text">مبلغ پیش‌فرض ارسال سفارش‌های سایت را به تومان وارد کنید.</p>
      <v-alert v-if="error" type="error" outlined>{{ error }}</v-alert>
      <v-alert v-if="notice" type="success" outlined>{{ notice }}</v-alert>
      <v-progress-linear v-if="loading" indeterminate class="mb-4" />
      <v-form v-if="loaded" ref="form" @submit.prevent="save">
        <p class="text-body-2">روش ارسال: {{ methodName }}</p>
        <v-text-field v-model="amount" label="هزینه ارسال (تومان)" outlined inputmode="numeric"
          :disabled="busy" :rules="[amountRule]" hint="برای ارسال رایگان، صفر وارد کنید." persistent-hint />
        <v-btn type="submit" color="primary" class="mt-4" :loading="saving" :disabled="busy">ذخیره هزینه ارسال</v-btn>
      </v-form>
      <v-btn text class="mt-4" :disabled="busy" @click="load">دریافت مبلغ فعلی</v-btn>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ShippingSettings',
  data: () => ({ amount: '', methodName: '', loaded: false, loading: false, saving: false, error: '', notice: '' }),
  computed: {
    isManager() { return !!(this.user && (this.user.user_type === 'ma' || this.user.is_superuser)) },
    canLoad() { return this.isManager && !!this.token },
    busy() { return this.loading || this.saving },
  },
  watch: { canLoad: { immediate: true, handler(value) { if (value) this.load() } } },
  methods: {
    parseAmount(value) {
      const digits = '۰۱۲۳۴۵۶۷۸۹٠١٢٣٤٥٦٧٨٩'
      const text = String(value).replace(/[۰-۹٠-٩]/g, digit => String(digits.indexOf(digit) % 10)).replace(/[,،٬\s]/g, '')
      const number = Number(text)
      return /^\d+$/.test(text) && Number.isSafeInteger(number) && number <= 2147483647 ? number : null
    },
    amountRule(value) { return this.parseAmount(value) !== null || 'مبلغ را به‌صورت عدد صحیح و نامنفی وارد کنید.' },
    applyResult(data) { this.amount = String(data.base_price); this.methodName = data.name; this.loaded = true },
    fail(err) {
      const data = err && err.response && err.response.data
      this.error = (data && (data.detail || (data.base_price && data.base_price.join(' ')))) || 'دریافت یا ذخیره هزینه ارسال ناموفق بود.'
    },
    load() {
      if (!this.canLoad || this.busy) return
      this.loading = true; this.error = ''; this.notice = ''
      this.request({ url: this.endpoint('shop/shippingSettings'), method: 'get',
        success: data => { this.applyResult(data); this.loading = false },
        error: err => { this.fail(err); this.loading = false },
      })
    },
    save() {
      if (!this.canLoad || this.busy || !this.$refs.form.validate()) return
      this.saving = true; this.error = ''; this.notice = ''
      this.request({ url: this.endpoint('shop/shippingSettings'), method: 'patch', data: { base_price: this.parseAmount(this.amount) },
        success: data => { this.applyResult(data); this.saving = false; this.notice = 'هزینه ارسال ذخیره شد.' },
        error: err => { this.fail(err); this.saving = false },
      })
    },
  },
}
</script>
